import { useEffect, useState } from 'react'
import { NVButton } from '@nv/basic-components'
import { AuthCodeInput } from '@nv/components'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import styles from './QRCode.module.scss'

function QRCode({ qrCodeDataUrl, code, setCode, onSubmit }) {
  const { t } = useTranslation()
  const [codeError, setcodeError] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    code.length === 6 && handleSubmit()
  }, [code])

  const handleSubmit = async () => {
    setcodeError(false)
    const result = await onSubmit()
    if (!result || !result.success) setcodeError(true)
  }

  const StepLabel = ({ step, label }) => {
    return (
      <div className={styles['step']}>
        <div className={styles['step__number']}>
          <span className={styles['step__number__txt']}>{step}</span>
        </div>
        <span className={styles['step__label']}>{label}</span>
      </div>
    )
  }

  return (
    <div className={styles['container']}>
      <div className={styles['body']}>
        <span className={styles['title']}>{t('auth.qrCode.scanMe')}</span>
        <StepLabel step='1' label={t('auth.qrCode.setUpLoginMethod')} />

        <img className={styles['qr-img']} src={qrCodeDataUrl} alt='qr code' />

        <StepLabel step='2' label={t('auth.qrCode.enterVerificationCode')} />

        <AuthCodeInput code={code} setCode={setCode} length={6} codeError={codeError} />
      </div>

      <div className={styles['footer']}>
        <NVButton
          classes={{ container: styles['footer__cancel-btn'] }}
          view='secondary'
          text={t('buttons.cancel')}
          height={50}
          onClick={() => navigate('/voting/voter/my-account')}
        />

        {/* <NVButton text={t('buttons.next')} height={50} onClick={handleSubmit} disabled={code.length < 6} /> */}
      </div>
    </div>
  )
}

export default QRCode
